import { SHOW_MODAL, HIDE_MODAL } from './Modal.constant';

const initialState = {
  modalType: null,
  modalProps: {},
  active: false,
};

export default function modalReducer(state = initialState, action) {
  switch (action.type) {
    case SHOW_MODAL:
      return {
        ...state,
        ...action.payload,
        active: true,
      };

    case HIDE_MODAL:
      return {
        ...state,
        modalType: null,
        modalProps: {},
        active: false,
      };
    default:
      return state;
  }
}
